<template>
    <div class="article-container">
        <div class="articleInput">
            <input @keydown.enter="pageIndex = 1; getArticle()" placeholder="请输入你想查询的关键词" type="text" v-model="articleValue">
            <img @click="pageIndex = 1; getArticle()" src="../../../common/newMaterialBox/assets/search.png" alt="">
        </div>
        <div v-if="showResult" class="result">
            <i></i>
            <p>共检索到 {{totalNum}} 个结果</p>
        </div>
        <ul ref="articleList" @scroll="listScroll($event)">
            <li v-for="(item,index) in list" :key="index" @click="emitId(item)">
                <i></i>
                <p v-html="item.title"></p>
            </li>
        </ul>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialArticle',
    data() {
        return {
            articleValue: '',
            pageIndex: 1,
            pageSize: 30,
            list: [],
            totalNum: 0,
            showResult: false
        }
    },
    props: {
        data: {
            type: Object
        },
        keywords: {
            type: String
        }
    },
    methods: {
        clearSearch() {
            this.articleValue = '';
            this.pageIndex = 1; 
            this.getArticle();
        },
        deposeAudioSrc(html) {
            if (!html) return html;
            let p = document.createElement("p");
            p.innerHTML = html;
            let audios = p.querySelectorAll("audio");
            audios.forEach(audio => {
                let _src = audio.dataset.src;
                console.log("deposeAudioSrc _src", _src);
                if (_src) {
                audio.src = _src;
                }
                audio.setAttribute('controls', true)
                audio.setAttribute('style', 'width: 100%')
                common.replaceXNSAudios1(audio);
                console.log("转换好src", audio);
            });
            return p.innerHTML;
        },
        emitId(item) {
            item.content = this.deposeAudioSrc(item.content)
            this.$emit('getId', item)
        },
        getArticle() {
            if(this.data.isStream){
                const info = {
                    id: this.data.id,
                    type: this.data.type,
                    keywords: this.keywords ? this.keywords : ''
                };

                common.myFetch(apis.streammediaContents, info).then(r => {
                    if (r) {
                        console.log(r);
                        // this.totalNum = r.page.row_count
                        if(this.articleValue){
                            this.showResult = true
                        }else{
                            this.showResult = false
                        }
                        this.$emit('showResult',this.showResult)
                        if(this.pageIndex === 1){
                            this.list = r.list
                        }else{
                            this.list = this.list.concat(r.list)
                        }

                        this.list = this.list.filter(el => {
                            return el.title.indexOf(this.articleValue) != -1
                        })

                        this.totalNum = this.list.length
                    }
                });
            }else{
                const info = {
                    id: this.data.id,
                    key_words: this.articleValue,
                    page: this.pageIndex,
                    pagesize: this.pageSize,
                    keywords: this.keywords ? this.keywords : ''
                };

                common.myFetch(apis.fileContent, info).then(r => {
                    if (r) {
                        console.log(r);
                        this.totalNum = r.page.row_count
                        if(this.articleValue){
                            this.showResult = true
                        }else{
                            this.showResult = false
                        }
                        this.$emit('showResult',this.showResult)
                        if(this.pageIndex === 1){
                            this.list = r.list
                        }else{
                            this.list = this.list.concat(r.list)
                        }
                    }
                });
            }
        },
        listScroll($event) {
            if ((parseInt($event.target.clientHeight) + parseInt($event.target.scrollTop)) === parseInt($event.target.scrollHeight)) {
                this.pageIndex ++;
                this.getArticle()
            }
        }
    },
    mounted() {
        this.getArticle()
    }
}
</script>

<style lang="less" scoped>
    .article-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 14px 20px;
        box-sizing: border-box;

        .result {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 18px;

            i {
                display: block;
                width: 6px;
                height: 6px;
                background: #B9C3C3;
                border-radius: 50%;
                margin-right: 8px;
            }

            p {
                font-size: 13px;
                line-height: 18px;
                color: #829191;
                font-weight: 500;
            }
        }

        .articleInput {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            height: 40px;
            background: rgba(207, 215, 219, 0.2);
            border-radius: 6px;
            padding: 0 20px;
            box-sizing: border-box;
            margin-bottom: 20px;

            input {
                width: 100%;
                height: 100%;
                background: transparent;
                font-size: 14px;

                &::placeholder {
                    color: #B9C3C3;
                }
            }

            img {
                user-select: none;
                cursor: pointer;
            }
        }

        ul {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(#D8D8D8, 1);
                border-radius: 4px;
            }

            li {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                margin-bottom: 16px;
                user-select: none;
                cursor: pointer;

                &:hover {
                    i {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('../../../common/newMaterialBox/assets/littleFileOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 10px;
                    }

                    p {
                        color: #41B48C;
                    }
                }

                &.on {
                    i {
                        display: block;
                        width: 24px;
                        height: 24px;
                        background: url('../../../common/newMaterialBox/assets/littleFileOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 10px;
                    }

                    p {
                        color: #41B48C;
                    }
                }

                i {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background: url('../../../common/newMaterialBox/assets/littleFile.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                }

                p {
                    flex: 1;
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    font-weight: 500;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>

<style lang="less">
.article-container {
    em {
        color: #41b48c;
        font-style: normal;
    }
}
</style>